import { AutopilotTaskDto } from '@urbanx/agx.activities.client'
import { IconTaskTypes } from '@urbanx/agx.ui-components2'
import TaskDueDateBadge from 'components/tasks/TaskDueDateBadge'
import TaskModalEntry from 'pages/allTasks/TaskModal/TaskModalEntry'
import { JSX, useState } from 'react'
import { getStepsCompletionInfo } from 'utils/tasks'
import ContractComplianceModal from './ContractComplianceModal'

interface ContractComplianceProps {
  campaignId: string
  tasks: AutopilotTaskDto[]
}

const ContractCompliance = ({ campaignId, tasks }: ContractComplianceProps) => {
  const [isContractComplianceModalOpen, setIsContractComplianceModalOpen] =
    useState(false)
  const { allStepsCompleted, latestCompletedDate } =
    getStepsCompletionInfo(tasks)

  const badge: JSX.Element = (
    <TaskDueDateBadge
      dueDate={
        tasks
          .map((task) =>
            new Date(allStepsCompleted ? latestCompletedDate! : task.dueDate!)
          )
          .sort((a, b) => a.getTime() - b.getTime())[0] as unknown as string
      }
      isCompleted={allStepsCompleted}
      completedDate={latestCompletedDate}
    />
  )

  return (
    <>
      <ContractComplianceModal
        campaignId={campaignId}
        isOpen={isContractComplianceModalOpen}
        onClose={() => setIsContractComplianceModalOpen(false)}
        tasks={tasks}
      />
      <TaskModalEntry
        title="Contract Compliance"
        tasks={tasks}
        badge={badge}
        iconType={IconTaskTypes.AgreementCompliance}
        actionText="Complete Compliance Check"
        actionButtonId="completeContractComplianceCheckBtn"
        panelKey="ContractCompliancePanel"
        whiteStepsBackground
        onAction={() => setIsContractComplianceModalOpen(true)}
      />
    </>
  )
}

export default ContractCompliance
